import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'
import facebookPixel from './facebook'
import posthog from "analytics-plugin-posthog";


const onlyGoogleAnalytics = {
  plugins: {
    "facebook": false,
    "google-analytics": true,
  }
}

const onlyFacebook = {
  plugins: {
    "facebook": true,
    "google-analytics": false,
  }
}
/**
 * Track a purchase event
 * @param {Object} params - Purchase details
 * @param {string} params.transactionId - Unique transaction ID
 * @param {number} params.value - Purchase amount
 * @param {string} params.currency - Currency code (e.g., 'EUR', 'USD')
 * @param {Array<Object>} params.items - Array of items purchased
 * @param {string} params.coupon - Coupon code used (if any)
 */
const trackPurchase = (analytics, { transactionId, value, currency, items = []}) => {

  analytics.track('purchase', {
    transaction_id: transactionId,
    value: value,
    currency: currency,
    items: items.map((item) => {
      return {
        item_id: item.id,
        name: item.name,
        price: item.price,
        quantity: item.quantity,
      };
    }),
  }, onlyGoogleAnalytics);


  analytics.track('Purchase', {
    value: value,
    currency: currency,
    content_name: items[0]?.name,
    content_ids: items.map((item) => item.id),
    contents: items.map((item) => {
      return {
        id: item.id,
        quantity: item.quantity,
      };
    })
  }, onlyFacebook);
};

/**
 * Track when a user starts the checkout process
 * @param {Object} params - Checkout details
 * @param {string} params.currency - Currency code (e.g., 'EUR', 'USD')
 * @param {number} params.value - Total cart value
 * @param {Array<Object>} params.items - Array of items in cart
 */
const trackCheckoutStarted = (analytics, { currency, value, items = [] }) => {

  analytics.track('begin_checkout', {
    currency: currency,
    value: value,
    items: items,
  }, onlyGoogleAnalytics);

  analytics.track('InitiateCheckout', {
    content_ids: items.map((item) => item.id),
    contents: items.map((item) => {
      return {
        id: item.id,
        quantity: item.quantity,
      };
    }),
    num_items: items.length,
    value: value,
    currency: currency,
  }, onlyFacebook);
};

const trackSignup = (analytics) => {
  // ga4 events
  analytics.track('generate_lead', {}, onlyGoogleAnalytics);
  analytics.track('sign_up', {}, onlyGoogleAnalytics);

  // fb events
  analytics.track('CompleteRegistration', {}, onlyFacebook);
  analytics.track('Lead', {}, onlyFacebook);
};


const trackLogin = (analytics) => {
  analytics.track('login', {}, onlyGoogleAnalytics);
}

export default {
  install: (app, { router }) => {
    const analytics = Analytics({
      app: import.meta.env.VITE_APP_FIREBASE_PROJECT_ID,
      plugins: [
        googleAnalytics({
          measurementIds: [import.meta.env.VITE_APP_FIREBASE_MEASUREMENT_ID],
        }),
        facebookPixel({
          pixelId: import.meta.env.VITE_APP_FACEBOOK_PIXEL_ID,
        }),
        posthog({
          token: import.meta.env.VITE_APP_POSTHOG_API_KEY,
          apiHost: import.meta.env.VITE_APP_POSTHOG_API_HOST,
        }),
        // Add more plugins here
      ]
    })

    // Add custom tracking methods
    const analyticsWithCustomEvents = {
      ...analytics,
      trackPurchase: (params) => trackPurchase(analytics, params),
      trackCheckoutStarted: (params) => trackCheckoutStarted(analytics, params),
      trackSignup: () => trackSignup(analytics),
      trackLogin: () => trackLogin(analytics),
    };

    // Provide $analytics globally with custom methods
    app.config.globalProperties.$analytics = analyticsWithCustomEvents;
    app.provide('analytics', analyticsWithCustomEvents);

    // Track page views on router navigation
    router.afterEach((to) => {
      analytics.page({
        url: to.fullPath,
        title: document.title,
        path: to.path
      })
    })
  }
}